import Vue from "vue";
import { i18nFactory } from "./i18n";

export function vueFactory(options) {
  return new Vue({
    i18n: i18nFactory(),
    ...options,
  });
}
